import * as React from 'react';
import { IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './RoundArrowLeft.css';

interface IRoundArrowRightProps {
  onClick(): void;
  topOffset?: number;
}

export const RoundArrowLeft: React.FC<IRoundArrowRightProps> = ({ onClick, topOffset }) => {
  const style =
    topOffset !== undefined
      ? {
          top: `${topOffset}px`,
          alignSelf: 'start',
        }
      : undefined;

  return (
    <div className={styles['arrow']} style={style} onClick={onClick}>
      <IconActionChevronLeft16 color="icon-secondary-default" />
    </div>
  );
};
